import { render } from "./fundings-subpage.vue?vue&type=template&id=30c74adf"
import script from "./fundings-subpage.vue?vue&type=script&lang=js"
export * from "./fundings-subpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__